module.exports = __webpack_public_path__ + "static/img/s-vivo-2.38eec19.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-vivo-2.png
// module id = kf3n
// module chunks = 1